<template>
  <div class="WxOption">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>

        <el-input v-if="radio == '条件查询'" placeholder="手机号 用户名 ID" v-model="merInputVal" size="medium"
          style="width: 300px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>

        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>
        <el-radio v-model="partnerType" label="1" class="x-m-l-20 x-m-r-5" @change="nowPage=1;init('chgTable')">商户信息</el-radio>
        <el-radio v-model="partnerType" label="2" class="x-m-l-20 x-m-r-5" @change="nowPage=1;init('chgTable')">微信账户</el-radio>
      </div>
      <div class="x-flex">
        <el-button type="danger" size="medium" @click="fRegWxUser">{{partnerType=='1'?'增加商户':'增加微信账户'}}</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :title="partnerType=='1'?'商户手机号':'绑定手机号'" width="180px">
            <template slot-scope="scope">
              <span>{{partnerType=='1'?scope.row.user_phone:scope.row.partner_phone}}</span>
            </template>
          </vxe-column>
          <vxe-column :title="partnerType=='1'?'商户名称':'微信主体名'" min-width="180px">
            <template slot-scope="scope">
              <span>{{partnerType=='1'?scope.row.user_name:scope.row.partner_name}}</span>
            </template>
          </vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :min-width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
                <!--                <span class="x-flex" style="flex-direction: column">
                  <i :class="[
                      'el-icon-caret-top',
                      sortType == item.sortType && sortAscDesc == 'asc'
                        ? 'active'
                        : '',
                    ]"></i>
                  <i :class="[
                      'el-icon-caret-bottom',
                      sortType == item.sortType && sortAscDesc == 'desc'
                        ? 'active'
                        : '',
                    ]"></i>
                </span> -->
              </div>
            </template>
          </vxe-column>

          <vxe-column fixed="right" title="操作" width="90" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-flex ">
                <!-- <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-l-4 x-m-r-20"
                  style="color: #2c8ff2">
                  修改
                </el-button>
                <el-button type="text" size="mini" @click="fDel(scope.row)" class="x-m-l-4 x-m-r-20"
                  style="color: #2c8ff2">
                  删除
                </el-button> -->
                <div style="color: #2c8ff2; cursor: pointer;" @click="fModify(scope.row)">修改</div>
                <div class="x-m-l-10" style="color: #2c8ff2; cursor: pointer;" @click="fDel(scope.row)">删除</div>
              </div>

            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange" :current-page="nowPage"
          :page-size="50" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditAgent" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="8vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600" v-if="partnerType=='1'">
          {{ WxOptionAddOrEdit == "MCH_EDIT" ? "增加商户" : "修改商户" }}
        </div>
        <div class="x-font-15 f600" v-else>
          {{ WxOptionAddOrEdit == "MCH_EDIT" ? "增加微信账户" : "修改微信账户" }}
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSaveWxOption">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 手机号  商户名称-->
      <el-row class="x-m-t-15" :gutter='7' v-if="partnerType == '2'">
        <el-col class="x-flex x-row-right" :span="8">
          <div class="x-w90 x-text-r x-p-t-7 x-p-r-15  must">微信类型</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <!-- <el-input size="small" class="x-flex-1" v-model="userInfo.wxType" type="number"
            :disabled="WxOptionAddOrEdit == 'Edit' ? true : false"></el-input> -->
          <el-select class="x-w100p" v-model="userInfo.wxType" placeholder="" @change="" size="small">
            <el-option v-for="item in wxTypeOption" :key="item.value" :label="item.lebal" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :gutter='7'>
        <el-col class="x-flex x-row-right" :span="8">
          <div class="x-w140 x-text-r x-p-t-7 x-p-r-15  must">微信主体手机号</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <el-input size="small" class="x-flex-1" v-model="userInfo.partnerPhone" type="number"
            :disabled="WxOptionAddOrEdit == 'Edit'  && partnerType=='2'? true : false"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :gutter='7' v-if="partnerType == '1'">
        <el-col class="x-flex x-row-right" :span="8">
          <div class="x-w100 x-text-r x-p-t-7 x-p-r-15  must">商户手机号</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <el-input size="small" class="x-flex-1" v-model="userInfo.userPhone" type="number"
            :disabled="WxOptionAddOrEdit == 'Edit' ? true : false"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :class="partnerType=='1'?'x-p-b-30':''" :gutter='7'>
        <el-col class="x-flex x-row-right" :span="8">

          <div class="x-w100 x-text-r x-p-t-7 x-p-r-15 must">{{partnerType=='1'?'商户名称':'微信主体名'}}</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <el-input size="small" class="x-flex-1" v-model="userInfo.userName"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :gutter='7' v-if="partnerType == '2'">
        <el-col class="x-flex x-row-right" :span="8">
          <div class="x-w90 x-text-r x-p-t-7 x-p-r-15 must">微信AppId</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <el-input size="small" class="x-flex-1" v-model="userInfo.appId"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :gutter='7' v-if="partnerType == '2'">
        <el-col class="x-flex x-row-right" :span="8">

          <div class="x-w120 x-text-r x-p-t-7 x-p-r-15 must">微信AppSecret</div>
        </el-col>
        <el-col class="x-flex" :span="11">
          <el-input size="small" class="x-flex-1" v-model="userInfo.appSecret"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-m-t-15" :gutter='7' v-if="partnerType == '2'">
        <el-col class="x-flex x-row-right" :span="8">

          <div class="x-w120 x-text-r x-p-t-7 x-p-r-15 must">微信文件名</div>
        </el-col>
        <el-col class="x-flex x-m-b-10" :span="11">
          <div class="">
            <el-upload :on-change='uploadOnChange' action="https://soft.sanmipos.com/" :data="ossParams"
              :auto-upload="false" :show-file-list="true" ref="upload" :before-upload='beforeUpload'
              :on-success="fUploadSucess" :limit="1" :on-error="fUploadError" :file-list="fileLise">
              <el-button size="small" type="primary" slot="trigger">选择</el-button>
              <!-- <el-button class="x-m-l-10" size="small" type="success" @click=''>点击上传</el-button> -->
            </el-upload>

          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        partnerType: '1',
        radio: "条件查询",
        merInputVal: "",
        // uploadImgValue:'',//上传的文件名称
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        tableJson: [
          // {
          //   // 循环渲染数据
          //   id: 2,
          //   title: "手机号",
          //   width: "120",
          //   sortType: "user_phone",
          // },
          // {
          //   id: 3,
          //   title: "商户名称",
          //   width: "180",
          //   sortType: "user_name",
          // },
          {
            id: 4,
            title: "微信AppId",
            width: "160",
            sortType: "app_id",
          },
          {
            id: 5,
            title: "微信AppSecret",
            width: "260",
            sortType: "app_secret",
          },
          {
            id: 6,
            title: "微信文件名",
            width: "240",
            sortType: "wx_file_name",
          },
          // {
          //   id: 7,
          //   title: "accessToken",
          //   width: "180",
          //   sortType: "access_token",
          // },
          {
            id: 8,
            title: "accessTokenFailTime",
            width: "180",
            sortType: "access_token_fail_time",
          },
          // {
          //   id: 9,
          //   title: "jsapiTicket",
          //   width: "180",
          //   sortType: "jsapi_ticket",
          // },
          {
            id: 10,
            title: "jsapiTicketFailTime",
            width: "180",
            sortType: "jsapi_ticket_fail_time",
          }
        ],
        wxTypeOption: [{
            lebal: '公众号',
            value: 'gzh',
          },
          {
            lebal: '小程序',
            value: 'xcx',
          }
        ],
        addOrEditAgent: false, // 增加/修改用户
        WxOptionAddOrEdit: "MCH_EDIT",
        userInfo: {
          wxType: 'gzh',
          partnerPhone: '',
          userPhone: "", // 手机号
          userName: "", // 联系人
          appId: "", // 登录密码
          appSecret: '', //AppSecret
          wxFileName: '', //微信文件名
        },
        //阿里云服务器
        ossParams: {
          key: '', // key后面有用，先默认设空字符串
          success_action_status: '200', // 默认200
          policy: '',
          OSSAccessKeyId: "LTAI5tMQB1vesaRbUoqheH7m",
          signature: "pOQsOgE8xqk8Cvsq+d7Qsf/8iDQ=",

        },
        upFileData: {
          "serverFilePath": "D:\\web\\",
          "file1name": "pages-json.txt",
          "file1": "pages-json.txt"
        }

      };
    },
    created() {
      this.init();
      // this.fGetAliOssSign()
    },
    methods: {
      async init(chgTable) {
        if (chgTable == 'chgTable') {
          this.nowPage = 1
        }
        let res = await this.fWxUserInfo('GET_MCH_LIST');


        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = res.data[0].TR; //总条数
          this.TP = res.data[0].TP; //总页数
        }
        this.tableData = res.data;
      },

      //删除
      async fDel(row) {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let oper = this.partnerType == '1' ? 'MCH_DEL' : 'ORG_DEL';
          let res = await this.fWxUserInfo(oper, row.user_phone, row.partner_phone);
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.init();
        }).catch(() => {});
      },
      async fModify(row) {
        this.WxOptionAddOrEdit = "Edit";
        this.fileLise = []
        this.addOrEditAgent = true;
        let res = await this.fWxUserInfo(
          "GET_MCH_ID",
          row.user_phone,
          row.partner_phone
        );


        if (res.result != "sucess") {
          return this.$message(res.msg);
        }


        this.userInfo.wxType = res.data[0].wx_type;
        this.userInfo.partnerPhone = res.data[0].partner_phone;
        this.userInfo.userPhone = res.data[0].user_phone;
        this.userInfo.userName = res.data[0].user_name || res.data[0].partner_name;
        this.userInfo.appId = res.data[0].app_id;
        this.userInfo.appSecret = res.data[0].app_secret;
        this.userInfo.wxFileName = res.data[0].wx_file_name;
      },

      async fSaveWxOption() {
        if (this.partnerType == '2') {
          // if (this.WxOptionAddOrEdit == 'MCH_EDIT' || this.WxOptionAddOrEdit == 'Edit') {
          //   if (this.fileLise.length <= 0) {
          //     return this.$message('请选择文件');
          //   }
          // }
          if (this.fileLise.length > 0) {
            await this.fGetAliOss()
            this.$refs.upload.submit()
          } else {
            this.fWxOper()
          }
        }
        if (this.partnerType == '1') {
          if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.partnerPhone)) {
            return this.$message("请输入上级手机号");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.userPhone)) {
            return this.$message("请输入手机号");
          }
          if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.userName)) {
            return this.$message("请输入商户名称");
          }
          let res = await this.fWxUserInfo('MCH_EDIT');
          if (res.result != "sucess") {
            return this.$message(res.msg);
          }
          this.$message(res.msg);
          this.init();
          this.fClose();
        }

      },
      fClose() {
        this.addOrEditAgent = false;
        this.fileLise = []
        this.userInfo = Object.assign({
          wxType: 'gzh',
          partnerPhone: '',
          userPhone: "", // 手机号
          userName: "", // 联系人
          appId: "", // 登录密码
          appSecret: '', //AppSecret
          wxFileName: '', //微信文件名
        });
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        //
        //
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fRegWxUser() {
        this.WxOptionAddOrEdit = "MCH_EDIT";
        this.addOrEditAgent = true;
        this.fileLise = []
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fWxUserInfo('GET_MCH_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },
      async fGetAliOss() {
        // 从服务端获取到签名的处理
        let res = await this.fGetAliOssSign()
        if (res.result != 'sucess') {
          return this.$message(res.msg)
        }
        this.ossParams.policy = res.data.policy
        this.ossParams.OSSAccessKeyId = res.data.ossAccessId
        this.ossParams.signature = res.data.signature
        this.expirTime = res.data.expirTime
        return
      },
      // 文件上传之前
      beforeUpload(file) {
        console.log(file)
        this.ossParams.key = file.name;
        this.userInfo.wxFileName = file.name
        console.log(this.ossParams)
      },
      //提交微信参数
      async fWxOper() {


        if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.wxType)) {
          return this.$message("请输入微信类型");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.partnerPhone)) {
          return this.$message("请输入上级手机号");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.userName)) {
          return this.$message("请输入商户名称");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.appId)) {
          return this.$message("请输入微信AppId");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.appSecret)) {
          return this.$message("请输入AppSecret");
        }
        // if (this.bykApi.smCom.fSmIsEmpty(this.userInfo.wxFileName)) {
        //   return this.$message("请上传微信文件");
        // }
        //

        let res = await this.fWxUserInfo('MCH_EDIT');

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.$message(res.msg);
        this.init();
        this.fClose();

      },
      //文件上传成功后 提交微信信息
      async fUploadSucess(e) {
        let resUpload = await this.fUpLoadWxFile()
        if (resUpload != "sucess") {
          return this.$message(resUpload);
        }
        console.log(e)
        this.fWxOper()
      },
      //文件上传失败后 返回数据
      fUploadError(e) {
        this.$message('文件上传失败');
      },

      async fUpLoadWxFile() {

        // let res1 = await this.fUploadFile("http://8.142.32.47:1880/fileServerApi.asq");
        // if (res1.result != 'sucess') {
        //   return res1.msg + '：' + '8.142.32.47';
        // }
        // this.bykApi.global.smPayAdmin.sys.mainSrvUrl + '/smPayMain/upFile/'
        // https://www.91byk.com/smSellMain/api/smSellApi/
        // let res2 = await this.fUploadFile("http://8.142.45.98:1880/fileServerApi.asq")
        let res2 = await this.fUploadFile("https://www.91byk.com/smSellMains/smGuard/upFile/")
        console.log(res2)
        if (res2.result != 'sucess') {
          return res2.msg + '：' + '8.142.45.98';
        }
        this.userInfo.wxFileName = res2.sub_msg
        return 'sucess'
      },

      //文件上传
      uploadOnChange(file, fileList) {
        this.fileLise = fileList
        this.userInfo.wxFileName = ''
        let formData = new FormData();
        // formData.append("serverFilePath", "D:\\web\\");
        // formData.append("file1name", file.name);
        // formData.append("file1", file.raw);
        formData.append("path",'D:\\web\\');
        formData.append(file.name, file.raw);
        this.upFileData = formData
      },
      async fUploadFile(url) {
        let formData = new FormData();
        formData = this.upFileData
        let result = {}
        await this.axios({
          method: "post",
          url: url,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }).then((res) => {
          //
          result = res.data
        });
        return result
        // });
      },

      // ------------- 请求 开始 --------------

      // 获取微信用户信息
      async fWxUserInfo(oper, userPhone, partnerPhone) {
        let js = {};
        js["OPER"] = oper;
        if (oper == 'MCH_EDIT') {
          js["OPER"] = this.partnerType == '1' ? 'MCH_EDIT' : 'ORG_EDIT';
          js["WX_TYPE"] = this.userInfo.wxType; // 公众号 gzh 小程序 xcx
          // js["PARTNER_PHONE"] = this.userInfo.partnerPhone; // 合作手机号
          js["ORG_ID"] = this.userInfo.partnerPhone; // 合作手机号
          js['ORG_NAME'] = this.userInfo.userName
          js["MCH_ID"] = this.userInfo.userPhone; // 合作手机号
          js["MCH_NAME"] = this.userInfo.userName; // 商户名称
          // js["SH_PHONE"] = this.userInfo.userPhone; // 商户手机号
          js["APP_ID"] = this.userInfo.appId; // 微信appID
          js["APP_SECRET"] = this.userInfo.appSecret;
          js["WX_FILE_NAME"] = this.userInfo.wxFileName; // 微信文件名

        } else if (oper == 'GET_MCH_LIST') {
          js["OPER"] = this.partnerType == '1' ? 'GET_MCH_LIST' : 'GET_ORG_LIST';
          js["SEARCH_STR"] = this.merInputVal; // 查询条件
          js["PAGE_SIZE"] = 50; // 页大小
          js["NOW_PAGE"] = this.nowPage; // 当前页
          js["MH_YN"] = this.checked ? "Y" : "N"; // 是否模糊

        } else if (oper == 'GET_MCH_ID') {
          // js["SH_PHONE"] = userPhone; // 商户手机号
          js["OPER"] = this.partnerType == '1' ? 'GET_MCH_ID' : 'GET_ORG_ID';
          // js["SH_PHONE"] = userPhone; // 商户手机号
          // js["PARTNER_PHONE"] = partnerPhone; // 商户手机号
          js["ORG_ID"] = partnerPhone; // 合作手机号
          js["MCH_ID"] = userPhone; // 合作手机号

        } else if (oper == 'MCH_DEL') {
          js["ORG_ID"] = partnerPhone; // 合作手机号
          js["MCH_ID"] = userPhone; // 合作手机号

        } else if (oper == 'ORG_DEL') {
          js["ORG_ID"] = partnerPhone; // 合作手机号
        }
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('WX_USER_INFO', js);
        console.log(res)
        return res;
      },
      //获取阿里oss参数
      async fGetAliOssSign() {
        let js = {};
        js['USER_PHONE'] = '18957102098'
        js['BUCKET'] = 'sanmipos' //byk-user sanmipos
        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi('GET_ALI_OSS_SIGN ', js)
        console.log(res)
        return res;
      },
      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .WxOption {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }
</style>



// WEBPACK FOOTER //
// src/view/wxOption.vue